import * as moment from 'moment';

import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en-GB';
import localeIt from '@angular/common/locales/it';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { LocalizeConfig } from './localize-config';

export const SUPPORTED_LANG = ['en-GB', 'it-IT'];

@Injectable()
export class LocalizeService {
  private readonly STORAGE_LANG_KEY = 'userSelectedLang';

  constructor(
    private config: LocalizeConfig,
    private translateService: TranslateService
  ) {}

  getCurrentLocale(): string {
    let lang = localStorage.getItem(this.STORAGE_LANG_KEY);
    if (!lang || SUPPORTED_LANG.indexOf(lang) < 0) {
      const browserLang = navigator.language;
      if (SUPPORTED_LANG.indexOf(browserLang) >= 0) {
        lang = browserLang;
      } else {
        lang = this.config.fallbackCulture;
      }
    }
    return lang;
  }

  setCurrentLocale(lang: string): void {
    if (SUPPORTED_LANG.indexOf(lang) >= 0) {
      localStorage.setItem(this.STORAGE_LANG_KEY, lang);
      window.location.reload();
    }
  }

  initLocalization(): void {
    const lang = this.getCurrentLocale();

    this.translateService.use(lang);
    moment.locale(lang);
    registerLocaleData(localeIt);
    registerLocaleData(localeEn);
  }
}
